import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  iconfont: 'mdi'
})

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#000000',
        secondary: '#ffffff',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
}

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js